var map = {
	"./Appointment.svg": 6858,
	"./ApproveAppointment.svg": 5841,
	"./Doodle.svg": 7720,
	"./FAQ.svg": 2109,
	"./Service.svg": 9096,
	"./Staff.svg": 6111,
	"./crmImage.svg": 3488,
	"./empty.svg": 3662,
	"./emptyAppointments.svg": 9820,
	"./emptyFaq.svg": 1262,
	"./emptyGallery.svg": 7532,
	"./emptyService.svg": 8227,
	"./freelancerlogo.svg": 2077,
	"./google_location.svg": 4568,
	"./homeIcon.svg": 4421,
	"./loadingstate.svg": 156,
	"./merchantslogo.svg": 1259,
	"./overviewClient.svg": 2839,
	"./sidebaricon.svg": 8990,
	"./staffAppointment.svg": 3862,
	"./staffEmail.svg": 1237,
	"./staffPhone.svg": 7181
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6599;